import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7603bb50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "parent-div-profile-info"
};
const _hoisted_2 = {
  class: "d-flex flex-row align-items-center justify-content-end gap-2"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0"
}, " Your password has been updated successfully! ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_app_card = _resolveComponent("app-card");
  return _openBlock(), _createBlock(_component_app_card, {
    title: "",
    scrollable: false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_app_input, {
      modelValue: $data.form.existing_password,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.existing_password = $event),
      readonly: !$data.isEdit,
      validateRule: "password",
      type: "password",
      label: "Existing Password",
      placeholder: "Please enter your existing password",
      required: "",
      onSubmit: $options.onSubmit
    }, null, 8, ["modelValue", "readonly", "onSubmit"]), _createVNode(_component_app_input, {
      modelValue: $data.form.new_password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.new_password = $event),
      readonly: !$data.isEdit,
      validateRule: "password",
      type: "password",
      label: "New Password",
      placeholder: "Please enter your new password",
      required: "",
      onSubmit: $options.onSubmit
    }, null, 8, ["modelValue", "readonly", "onSubmit"]), _createElementVNode("div", _hoisted_2, [!$data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
      key: 0,
      variant: "outline-primary",
      onClick: $options.onEdit
    }, {
      default: _withCtx(() => [_createTextVNode(" Change Password ")]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), $data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
      key: 1,
      variant: "outline-primary",
      onClick: $options.onCancel
    }, {
      default: _withCtx(() => [_createTextVNode(" Cancel ")]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), $data.isEdit ? (_openBlock(), _createBlock(_component_app_button, {
      key: 2,
      loading: $data.loading,
      onClick: $options.onSubmit
    }, {
      default: _withCtx(() => [_createTextVNode(" Save ")]),
      _: 1
    }, 8, ["loading", "onClick"])) : _createCommentVNode("", true)]), _createVNode(_component_app_modal, {
      modelValue: $data.showConfirmModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.showConfirmModal = $event),
      title: "Change Password",
      "no-cancel": "",
      onOk: _cache[3] || (_cache[3] = $event => $data.showConfirmModal = false)
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  });
}